import { CoordinationCard, CoordinationCardOptions } from 'data/models/CoordinationCard';
import { ReqChangeId, makePITKey, makePITDataKey } from './PITUtils';

export type CoordinationCardPITOptions = ReqChangeId<CoordinationCardOptions>;
export const CoordinationCardPITKey = makePITKey<CoordinationCard>(CoordinationCard.key);
export const CoordinationCardPITDataKey = makePITDataKey<CoordinationCardOptions>(CoordinationCard.dataKey);



// WEBPACK FOOTER //
// ./data/models/CoordinationCardPIT.ts